import React, { useState } from 'react';

import DemmiCard from '@demmi-ui/Card/Card';

import GeoLocationMap from '../../../../components/geoLocationMap/GeoLocationMap';
import DemmiButton from '@demmi-ui/Button';

import { DemmiFS } from '@subhanhabib/demmilib';

interface Props {
  CSSBlock: string;
  isLoading: boolean;
  customer: DemmiFS.User;
  onSave: (address: DemmiFS.DemmiAddress) => void;
}

const CustomerAddressGeo: React.FC<Props> = ({ CSSBlock, isLoading, customer, onSave }) => {
  const [address, setAddress] = useState<DemmiFS.DemmiAddress | undefined>(customer.address);

  const onCancel = () => setAddress(customer.address);
  const addressDefinitions = DemmiFS.DemmiAddressHelper.getFieldDefinitions(
    customer.address.countryCode,
  );

  return (
    <DemmiCard title="Geo" isLoading={isLoading}>
      <div className={`${CSSBlock}__geo`}>
        <GeoLocationMap countryCode={customer.address.countryCode} setAddress={setAddress} />
        <div className={`${CSSBlock}__address-preview`}>
          {Object.entries(addressDefinitions!).map(([key, value], i) => (
            <div className={`${CSSBlock}__details-item`} key={i}>
              <div className={`${CSSBlock}__details-key`}>{value.label}</div>
              <div className={`${CSSBlock}__details-value`}>
                {DemmiFS.DemmiAddressHelper.getFieldValue(key, address!)}
              </div>
            </div>
          ))}
        </div>
        <div className={`${CSSBlock}__buttons-row`}>
          <DemmiButton text="Cancel" onClick={onCancel} />
          <DemmiButton
            disabled={!address}
            text="Save"
            onClick={() => {
              if (address) onSave(address);
            }}
          />
        </div>
      </div>
    </DemmiCard>
  );
};

export default CustomerAddressGeo;
